import { forwardRef } from 'react';

import { StyledIcon } from '../../../material-ui-theme/components/styled/StyledIcon';

type IconWrapperProps = {
	icon: any;
	className: string;
};

export const StyledApprovalIconDisplayName = 'ApprovalIcon';

const IconWrapper = forwardRef<HTMLSpanElement, IconWrapperProps>(function IconWrapper(props, ref) {
	const { icon, className, ...other } = props;
	const StyledIconElement = StyledIcon.withComponent(icon);
	return <StyledIconElement className={className} ref={ref} {...other} />;
});

IconWrapper.displayName = 'IconWrapper';

export default IconWrapper;
